import LoadContentOnClick from "./loadContent";

export const loadContentOnClick = {
    init: () => {
      const loadMoreWrapper = document.getElementById("sd-load-more-onclick");
      const loadMoreButton = document.querySelectorAll(".sd-load-more-button");
      const loadMoreElements = document.querySelectorAll(".sd-load-more-el");
      if (loadMoreWrapper) {
        new LoadContentOnClick(loadMoreButton, loadMoreElements,loadMoreWrapper);
      }
    }
}

export default loadContentOnClick;